/**
 * Custom connection: name the tool, point at its API docs, say what the Teams
 * should do with it, and @yagni drafts the connector in the Ask dock. The
 * draft lands under Needs you as Pending setup; the key is added there, never
 * pasted into the chat.
 */
import { useState } from "react";
import { RecordHead, SheetFoot } from "../queue/index.js";

export function customConnectionPrompt(tool: string, docs: string, purpose: string): string {
  const lines = [`Draft a custom connection to ${tool.trim()}.`];
  if (docs.trim()) lines.push(`API docs: ${docs.trim()}`);
  if (purpose.trim()) lines.push(`What the Teams should do with it: ${purpose.trim()}`);
  lines.push("I will add the API key on the draft, not in this chat.");
  return lines.join("\n");
}

export function CustomConnectionSheet({ onStart, onCancel }: { onStart: (prompt: string) => void; onCancel: () => void }) {
  const [tool, setTool] = useState("");
  const [docs, setDocs] = useState("");
  const [purpose, setPurpose] = useState("");
  const ready = tool.trim().length > 1;

  return (
    <>
      <RecordHead
        recordKey="NEW CONNECTION"
        title="Custom connection"
        onClose={onCancel}
        noExpand
        meta={
          <span className="fact" style={{ fontSize: 11.5 }}>
            Describe the tool and YAGNI wires a connection from its API docs.
          </span>
        }
      />
      <div className="sbody" data-testid="custom-connection-sheet">
        <div className="field">
          <label htmlFor="custom-tool">Tool</label>
          <div className="in">
            <input
              id="custom-tool"
              placeholder="e.g. RealPage partner API"
              value={tool}
              onChange={(event) => setTool(event.target.value)}
              autoFocus
            />
          </div>
        </div>
        <div className="field">
          <label htmlFor="custom-docs">Docs</label>
          <div className="in mono">
            <input id="custom-docs" placeholder="https://" value={docs} onChange={(event) => setDocs(event.target.value)} />
          </div>
        </div>
        <div className="field top">
          <label htmlFor="custom-purpose">What for</label>
          <textarea
            id="custom-purpose"
            rows={3}
            placeholder="What the Teams should read or write"
            value={purpose}
            onChange={(event) => setPurpose(event.target.value)}
          />
        </div>
        <p className="body-p">Don't paste API keys here. The draft appears under Needs you, and the key goes on it.</p>
      </div>
      <SheetFoot
        why={
          <>
            This opens a chat with YAGNI to wire it. <b>Admins only.</b>
          </>
        }
        secondary={{ label: "Cancel", onClick: onCancel }}
        primary={{ label: "Start", onClick: () => onStart(customConnectionPrompt(tool, docs, purpose)), disabled: !ready }}
      />
    </>
  );
}
